import React from 'react';
import banner_filial_lp from '../assets/banner_filial_lp.png';
import { Link } from 'react-router-dom';
import '../css/Navbar.css';

const Navbar = ({ onLogout }) => {
  return (
    <>
      <nav className="navbar">
        <div className="container-fluid d-flex justify-content-between align-items-center">
          <Link className="navbar-brand" to="/">
            <img
              src={banner_filial_lp}
              alt="Logo"
              className="d-inline-block align-middle logo"
            />
          </Link>

          <div className="nav-tabs">
            <Link className="nav-link" to="/next-local-match">
              Próximo Viaje a ver al Rojo
            </Link>
            <Link className="nav-link" to="/next-away-match">
              Próximo Partido de Visitante
            </Link>
            <Link className="nav-link" to="/fixture">
              Fixture
            </Link>
            <Link className="nav-link" to="/announcements">
              Anuncios
            </Link>
            <Link className="nav-link" to="/notifications">
              Notificaciones
            </Link>
            <Link className="nav-link" to="/users">
              Usuarios
            </Link>
            <Link className="nav-link" to="/bus-stop">
              🚌 Ubicación de Micro
            </Link>
            <Link className="nav-link" to="/payments">
              💳 Pagos Proximo Viaje
            </Link>
            <Link className="nav-link" to="/clothing">
              👕 Indumentaria
            </Link>
            <button
              onClick={onLogout}
              className="nav-link"
              style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'white', fontWeight: 600 }}
            >
              Cerrar sesión
            </button>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
